import type { TvChannelProgram } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { ChannelProgramDays, ChannelProgramsGroupedByResourceDay } from '../types';

function getDateDayName(date: Date): ChannelProgramDays {
    const today = new Date();
    if (date.getFullYear() > today.getFullYear()) {
        return 'Tomorrow';
    }
    if (date.getFullYear() < today.getFullYear()) {
        return 'Yesterday';
    }
    if (date.getMonth() > today.getMonth()) {
        return 'Tomorrow';
    }
    if (date.getMonth() < today.getMonth()) {
        return 'Yesterday';
    }
    if (date.getDay() > today.getDay()) {
        return 'Tomorrow';
    }
    if (date.getDay() < today.getDay()) {
        return 'Yesterday';
    }

    return 'Today';
}

export const useChannelProgramsGroupedByDay = (
    programs: readonly TvChannelProgram[] | undefined
): ChannelProgramsGroupedByResourceDay | undefined =>
    programs?.reduce<ChannelProgramsGroupedByResourceDay>((acc, program) => {
        const dayTitle = getDateDayName(new Date(program.startTime));

        if (!acc[dayTitle]) {
            acc[dayTitle] = [];
        }

        acc[dayTitle]?.push(program);

        return acc;
    }, {});
